import { BuyEditProvider } from '@/contexts/BuyEditContext';
import { CreateEditBuyForm } from '@/components/Pages/Buys/Create/CreateEditBuyForm';
import { createFileRoute, Link, Navigate } from '@tanstack/react-router';
import { pageTitle } from '@/utils/pageTitle';
import { Stack, Breadcrumbs } from '@mui/joy';
import { useAuth } from '@/contexts/AuthContext';

export const Route = createFileRoute('/_protected/buys/create')({
  component: CreateBuy,
  head: () => pageTitle('Crear compra'),
});

function CreateBuy() {
  const { hasClaim, isLoading } = useAuth();
  const canWrite = hasClaim('BUY_WRITE');

  if (!isLoading && !canWrite) {
    return <Navigate to='/buys' />;
  }

  return (
    <>
      <Stack direction='row' justifyContent='space-between'>
        <Breadcrumbs size='sm'>
          <Link to='/buys'>Compras</Link>
        </Breadcrumbs>
      </Stack>

      <BuyEditProvider>
        <CreateEditBuyForm isCreate />
      </BuyEditProvider>
    </>
  );
}
